$(function(){
	var repeaterEls = $('.form-repeater');

	for(var i = 0; i < repeaterEls.length; i++){
		(function(){
			var repeaterEl = $(repeaterEls[i]);
			var itemsEl    = repeaterEl.find('.form-repeater__items')[0];
			var copyEl     = repeaterEl.find('.form-repeater__item--copy');

			// make items sortable
			if(itemsEl) {
				new Sortable(itemsEl, {
					animation: 150,
					ghostClass: 'form-repeater__item--dragged',
					handle: '[data-repeater-handle]',
					filter: '.locked',
					onMove: function (evt) {
				    if (evt.related)
				    {
				      return !evt.related.classList.contains('locked');
				    }
				  }
				});
			}

			// on add button click append new item
			repeaterEl.on('click', '[data-repeater-add]', function(){
				var cloneEl  = copyEl.clone();
				var inputEls = cloneEl.find('input');

				// replace data-name with name
				for(var y = 0; y < inputEls.length; y++) {
					var inputEl = $(inputEls[y]);
					var name    = inputEl.attr('data-name'); 

					inputEl.attr('name', name);
				}

				// remove copy class
				cloneEl.removeClass('form-repeater__item--copy');

				// append to items
				$(itemsEl).append(cloneEl);

				// reinitialize phone mask
				initPhoneMask();
			});

			// on remove button click remove item
			repeaterEl.on('click', '[data-repeater-remove]', function(){
				var thisEl = $(this);
				var itemEl = thisEl.closest('.form-repeater__item');

				itemEl.remove();
			});
		})();
	}
});